import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from './core/authentication.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService)
  const router = inject(Router)

  if (authService.loadSavedUserCookie()) {
    return true;
  }
  else {
    router.navigateByUrl('/login');
    return false;
  }
};
